import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const flightQuoteService = {
  listQuoteRequests: async () => {
    const response = await axios.get(`${API_BASE_URL}/flights/quote-requests`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getFlightQuotes: async () => {
    const response = await axios.get(`${API_BASE_URL}/flights/quote-requests`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getQuoteRequest: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/flights/quote-requests/detail`, {
      params: { requestId: id },
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getFlightQuoteById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/flights/quote-requests/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  updateQuoteRequest: async (id, payload) => {
    const response = await axios.post(`${API_BASE_URL}/flights/quote-requests/${id}/update`, payload, {
      headers: getAuthHeader(),
      timeout: 45000,
    });
    return response.data;
  },

  updateQuoteStatus: async (id, status, agentNotes) => {
    const response = await axios.patch(
      `${API_BASE_URL}/flights/quote-requests/${id}/status`,
      { status, agentNotes },
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  trackQuoteRequest: async (requestId, phone) => {
    const response = await axios.get(`${API_BASE_URL}/flights/quote-requests/track`, {
      params: { requestId, phone },
    });
    return response.data;
  },
};

export default flightQuoteService;
